import { useEffect } from 'react';

import { FabiJobSearchQueryGenerationUseCase } from '@xing-com/crate-common-graphql-types';
import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import {
  AI_SEARCH_INIT_PROMPT_PARAM,
  SEARCH_STATE_PARAMS,
} from '@xing-com/crate-jobs-constants';

const isValidCase = (
  caseValue: string
): caseValue is FabiJobSearchQueryGenerationUseCase =>
  [
    FabiJobSearchQueryGenerationUseCase.EarnMore,
    FabiJobSearchQueryGenerationUseCase.SearchWithProfile,
    FabiJobSearchQueryGenerationUseCase.SearchWithSkills,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  ].includes(caseValue as FabiJobSearchQueryGenerationUseCase);

export const useInitPromptOnLoad = ():
  | FabiJobSearchQueryGenerationUseCase
  | undefined => {
  const { getSearchParameter, deleteSearchParameter } = useSearchParameter();
  const initPromptOnLoad =
    getSearchParameter(AI_SEARCH_INIT_PROMPT_PARAM) ?? '';
  const keywords = getSearchParameter(SEARCH_STATE_PARAMS.keywords);

  useEffect(() => {
    if (initPromptOnLoad && keywords) {
      deleteSearchParameter(AI_SEARCH_INIT_PROMPT_PARAM);
    }
  }, [deleteSearchParameter, initPromptOnLoad, keywords]);

  return isValidCase(initPromptOnLoad) ? initPromptOnLoad : undefined;
};
